import axiosInstance from './axiosInstance';

export const getAllExtraSlips = () =>
    axiosInstance.get('/ExtraSlip').then(r => r.data);

export const getExtraSlipsByAgent = (agentId) =>
    axiosInstance.get(`/ExtraSlip/agent/${agentId}`).then(r => r.data);

export const getExtraSlipsByGroupName = (groupName) =>
    axiosInstance.get(`/ExtraSlip/group/${encodeURIComponent(groupName)}`).then(r => r.data);

export const createExtraSlip = (body) =>
    axiosInstance.post('/ExtraSlip', body).then(r => r.data);

export const approveExtraSlip = (slipId, remarks) =>
    axiosInstance.post(`/ExtraSlip/${slipId}/approve`, { remarks }).then(r => r.data);

export const rejectExtraSlip = (slipId, remarks) =>
    axiosInstance.post(`/ExtraSlip/${slipId}/reject`, { remarks }).then(r => r.data);

export const voidExtraSlip = (slipId, reason) =>
    axiosInstance.post(`/ExtraSlip/${slipId}/void`, { reason }).then(r => r.data);
